function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.667 9C.667 4.4 4.4.667 9 .667S17.333 4.4 17.333 9 13.6 17.333 9 17.333A8.336 8.336 0 01.667 9zm9.166 3.333V14H8.167v-1.667h1.666zM9 15.667A6.675 6.675 0 012.333 9 6.676 6.676 0 019 2.333 6.676 6.676 0 0115.667 9 6.676 6.676 0 019 15.667zM5.667 7.333a3.332 3.332 0 116.666 0c0 1.07-.658 1.645-1.299 2.205-.608.531-1.2 1.05-1.2 1.962H8.166c0-1.518.785-2.12 1.475-2.649.542-.415 1.025-.785 1.025-1.518 0-.916-.75-1.666-1.667-1.666s-1.667.75-1.667 1.666H5.667z",
  fill: "#005646"
});

function SvgHelperIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHelperIcon;